import {
  addMyPaymentTermOrder, addingMyPaymentTermOrderItem,
  setFeederServicePasswordTextInput, setFeederServicePasswordInputDialog,
  setMyPaymentTermSearchText, setTappedTermBlNo, setMyPaymentSelectedTab,
} from '../simple-action';
import { ROUTE_NAME_MY_PAYMENT } from '../../../constant';
import { uploadTermOrderItem } from '../../../helper';
import LocalizedString from '../../../localization';

export default (item, serviceName, password, navigateTo) => async (dispatch, getState) => {
  const { token } = getState().authentication;
  const { refNo, totalPrice } = item;

  try {
    dispatch(addingMyPaymentTermOrderItem(true));

    if (!password) {
      throw new Error(LocalizedString.common.errMsgEmptyPassword);
    }

    const itemSent = {
      blNumber: refNo,
      service: serviceName,
      amount: totalPrice,
      // paymentOnBehalfOf,
    };

    const itemGot = await uploadTermOrderItem(itemSent, token, password);

    dispatch(setFeederServicePasswordTextInput(''));
    dispatch(addMyPaymentTermOrder(itemGot));

    dispatch(setFeederServicePasswordInputDialog(false));

    dispatch(setMyPaymentTermSearchText(''));
    dispatch(setTappedTermBlNo(''));
    dispatch(setMyPaymentSelectedTab(1)); // term tab
    navigateTo(ROUTE_NAME_MY_PAYMENT);
  } finally {
    dispatch(addingMyPaymentTermOrderItem(false));
  }
};
